'use client'

import { X24 } from '@vinted/monochrome-icons'
import { Button, Cell, Divider, Dialog, Navigation, Spacer, Text } from '@vinted/web-ui'

import { SERVICE_FEE_HELP_URL, SERVICE_FEE_PRO_HELP_URL } from 'constants/routes'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  isSellerBusinessUser?: boolean
  isOpen: boolean
  onClose: () => void
}

const BundleRefundsBuyerProtectionFeeModal = ({
  isOpen,
  onClose,
  isSellerBusinessUser = false,
}: Props) => {
  const translate = useTranslate('bundle_refunds_buyer_protection_fee')
  const serviceFeeHelpUrl = isSellerBusinessUser ? SERVICE_FEE_PRO_HELP_URL : SERVICE_FEE_HELP_URL
  const translationKeyPrefix = isSellerBusinessUser ? 'pro_' : ''

  return (
    <Dialog show={isOpen}>
      <Navigation
        body={translate(`${translationKeyPrefix}title`)}
        right={
          <Button
            inline
            iconName={X24}
            styling={Button.Styling.Flat}
            testId="bundle-refunds-buyer-protection-fee-close"
            onClick={onClose}
            aria={{ 'aria-label': translate('a11y.close') }}
          />
        }
      />
      <Divider />
      <Cell>
        <Text as="span" text={translate(`${translationKeyPrefix}body`)} />
        <Spacer size={Spacer.Size.Large} />
        <a href={serviceFeeHelpUrl} target="_blank" rel="noreferrer">
          {translate('learn_more')}
        </a>
        <Spacer size={Spacer.Size.XLarge} />
        <Button text={translate('action')} styling={Button.Styling.Filled} onClick={onClose} />
      </Cell>
    </Dialog>
  )
}

export default BundleRefundsBuyerProtectionFeeModal
